import { ref } from "vue";

const opened = ref(false);
const confirmDialogData = ref<IConfirmData>();
import IConfirmData from "../types/ProDialogData";

export default () => {
    const show = (data: IConfirmData) => {
        confirmDialogData.value = data;
        opened.value = true;
    };

    return {
        opened,
        confirmDialogData,
        show,
    };
};
